<!-- SPDX-License-Identifier: AGPL-3.0-or-later -->
<link rel="preconnect" href="https://www.klubpfeilheim.at">
<div class="root-container">

    <div class="site-container">
        <img class="logo" src="https://www.klubpfeilheim.at/logo.svg" alt="Klub Pfeilheim"/>
        <div class="headlines-and-warnings">
            <h1>Anmeldung für das <br> {{ tournament?.name }}</h1>
            <h2>12.11.2026</h2>
            @if (tournament?.allRegularPlacesTaken) {
                <div class="warning-text">
                    <h3><b>Achtung!</b></h3>
                    <span>
                    @if (tournament?.waitingListActivated) {
                        Leider sind alle Plätze bereits belegt. Du kannst dich aber für die Warteliste registrieren und wir
                                werden auf dich zukommen, falls noch ein Platz frei wird.
                    } @else {
                        Leider sind alle Plätze bereits belegt. Komm trotzdem vorbei und schau dir das Turnier an! Nach dem Turnier werden alle Tische für freies Spiel geöffnet.
                    }
                    </span>
                </div>
            }
        </div>

        <div class="content-container">
            @if (!success) {
                @if (!tournament?.allRegularPlacesTaken || tournament?.waitingListActivated) {
                    <div class="form-container">
                        <form [formGroup]="newTeamNameForm" (ngSubmit)="createTeam()" class="form">
                            <mat-form-field [hideRequiredMarker]="hideRequiredMarker" appearance="outline"
                                            subscriptSizing="dynamic">
                                <mat-label>Teamname</mat-label>
                                <input
                                        matInput
                                        formControlName="name"
                                        data-cy="team-signup-name-input"
                                />
                                @if (nameFormControl.errors?.required) {
                                    <mat-error>Ihr braucht einen Teamnamen für euer Team.</mat-error>
                                }
                                @if (nameFormControl.errors?.minlength) {
                                    <mat-error>Der Teamname muss mindestens 3 Zeichen lang sein.</mat-error>
                                }
                                @if (nameFormControl.errors?.maxlength) {
                                    <mat-error>Der Teamname darf maximal 25 Zeichen lang sein.</mat-error>
                                }
                                @if (nameFormControl.errors?.teamAlreadyExists) {
                                    <mat-error>Der Teamname ist bereits vergeben, sorry.</mat-error>
                                }
                                @if (nameFormControl.errors?.maxParticipantsReached) {
                                    <mat-error>Es sind leider keine Plätze mehr frei.</mat-error>
                                }
                                @if (nameFormControl.errors?.registrationClosed) {
                                    <mat-error>Die Anmeldung ist leider geschlossen.</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field [hideRequiredMarker]="hideRequiredMarker" appearance="outline"
                                            subscriptSizing="dynamic">
                                <mat-label>Name 1. Teammitglied</mat-label>
                                <input matInput formControlName="person1Name" placeholder="Max Mustermann"/>
                                @if (person1NameFormControl.errors?.required) {
                                    <mat-error>Ihr müsst einen Namen für das 1. Teammitglied angeben.</mat-error>
                                }
                                @if (person1NameFormControl.errors?.minlength) {
                                    <mat-error>Der Name muss mindestens 1 Zeichen lang sein.</mat-error>
                                }
                                @if (person1NameFormControl.errors?.maxlength) {
                                    <mat-error>Der Name darf maximal 100 Zeichen lang sein.</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field [hideRequiredMarker]="hideRequiredMarker" appearance="outline"
                                            subscriptSizing="dynamic">
                                <mat-label>Name 2. Teammitglied</mat-label>
                                <input matInput formControlName="person2Name" placeholder="Marlene Musterfrau"/>
                                @if (person2NameFormControl.errors?.required) {
                                    <mat-error>Ihr müsst einen Namen für das 2. Teammitglied angeben.</mat-error>
                                }
                                @if (person2NameFormControl.errors?.minlength) {
                                    <mat-error>Der Name muss mindestens 1 Zeichen lang sein.</mat-error>
                                }
                                @if (person2NameFormControl.errors?.maxlength) {
                                    <mat-error>Der Name darf maximal 100 Zeichen lang sein.</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field [hideRequiredMarker]="hideRequiredMarker" appearance="outline"
                                            subscriptSizing="dynamic">
                                <mat-label>Handynummer</mat-label>
                                <input
                                        matInput
                                        formControlName="contactPhoneNumber"
                                        placeholder="+436641234567"
                                />
                                @if (contactPhoneNumberFormControl.errors?.minlength) {
                                    <mat-error>Die Handynummer muss mindestens 1 Zeichen lang sein.
                                    </mat-error>
                                }
                                @if (contactPhoneNumberFormControl.errors?.maxlength) {
                                    <mat-error>Die Handynummer darf maximal 16 Zeichen lang sein.
                                    </mat-error>
                                }
                                @if (contactPhoneNumberFormControl.errors?.pattern) {
                                    <mat-error> Die Handynummer scheint nicht gültig zu sein.
                                        Bitte schreibe alles zusammen ohne Leerzeichen und fang mit dem Ländercode (z.B.
                                        +43) an.
                                    </mat-error>
                                }
                                @if (contactPhoneNumberFormControl.errors?.required) {
                                    <mat-error>Ihr müsst eine Handynummer angeben.</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field [hideRequiredMarker]="hideRequiredMarker" appearance="outline"
                                            subscriptSizing="dynamic">
                                <mat-label>Email</mat-label>
                                <input
                                        matInput
                                        formControlName="contactEmail"
                                        placeholder="max.muster@mail.com"
                                />
                                @if (contactEmailFormControl.errors?.email) {
                                    <mat-error> Die Email scheint nicht gültig zu sein.
                                    </mat-error>
                                }
                                @if (contactEmailFormControl.errors?.required) {
                                    <mat-error>Ihr müsst eine Email angeben!</mat-error>
                                }
                            </mat-form-field>
                            <mat-form-field [hideRequiredMarker]="hideRequiredMarker" appearance="outline"
                                            subscriptSizing="dynamic">
                                <mat-label>Heim</mat-label>
                                <mat-select formControlName="livesAt">
                                    <mat-option [value]="LivesAtEnum.Pfeilheim3A">Pfeilheim 3A</mat-option>
                                    <mat-option [value]="LivesAtEnum.Pfeilheim46">Pfeilheim 4-6</mat-option>
                                    <mat-option [value]="LivesAtEnum.Extern">Extern</mat-option>
                                </mat-select>
                                @if (person2NameFormControl.errors?.required) {
                                    <mat-error>Ihr müsst eingeben in welchen Heim ihr wohnt. Wenn ich nicht in einem
                                        Pfeilheim wohnt, wählt bitte "Extern".
                                    </mat-error>
                                }
                            </mat-form-field>
                            <button mat-stroked-button type="submit" [disabled]="submitting">
                                @if (submitting) {
                                    <mat-spinner class="submit-spinner" diameter="20"></mat-spinner>
                                } @else if (tournament?.allRegularPlacesTaken) {
                                    Auf Warteliste setzen
                                } @else {
                                    Anmelden
                                }
                            </button>
                            <span class="datenschutz-info">
                                Mit dem Absenden des Formulars erklärst du dich mit unseren
                                <a href="https://docs.google.com/document/d/1Z47erBb5qG2XHg1eqj7sMr8ww754vIbwKaftsQWYg7c/edit?usp=sharing"
                                   target="_blank">Datenschutzbestimmungen</a>
                                einverstanden.
                            </span>
                        </form>
                    </div>
                }
                <div class="info-container">
                    <p>Unser mittlerweile legendäres Charity Beerpongturnier geht heuer in die 5. Runde! Sei dabei und
                        kämpfe
                        mit
                        deinem Team (2 Personen) um Pfeili-Ehre und tolle Preise. <br>
                        Der Reinerlös wird wie auch letztes Jahr an die <a href="https://www.gruft.at/">Caritas
                            Gruft</a> gespendet, um obdachlosen Menschen in
                        Wien zu helfen – also anmelden, Spaß haben und Gutes tun! Wir freuen uns auf euch! </p>
                    <b>Startgeld:</b> 15€/Team (bitte genau in Bar mitnehmen.) <br>
                    <b>Beginn:</b> 12.11.2026 19:00 / Klub Pfeilheim 3A (Bitte pünktlich sein!)<br>
                    <p>
                        <b>PS</b>: Wir spielen nach dem offiziellen Pfeilheim Regelwerk. Wenn ihr damit noch nicht
                        vertraut
                        seid,
                        schaut euch die Regeln bitte vorher an. <br>
                        Ihr findet sie <a href="https://www.pfeilheim4-6.at/Beerpongregeln.pdf" target="_blank">hier</a>.
                    </p>
                </div>
            } @else {
                <div class="success-message">
                    <h2>
                        @if (tournament?.allRegularPlacesTaken && tournament?.waitingListActivated) {
                            Erfolgreich auf Warteliste gesetzt
                        } @else {
                            Erfolgreich angemeldet
                        }
                    </h2>
                    <h3>
                        @if (tournament?.allRegularPlacesTaken && tournament?.waitingListActivated) {
                            Vielen Dank für deine Anmeldung zur Warteliste. Wir melden uns, sobald ein Platz frei wird!
                        } @else {
                            Vielen Dank für deine Teilnahme am {{ tournament?.name }}!
                        }
                    </h3>
                    <p>Du bekommst in Kürze eine Bestätigung per E-Mail. Falls sie nicht ankommt, schau bitte auch im Spam-Ordner nach.</p>
                </div>
            }
        </div>
    </div>
</div>